import React, { useState } from 'react';


const benefits = [
  {
    icon: (
      <svg width="36" height="36" fill="none" stroke="#FE6019" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M12 8v4l3 3" /></svg>
    ),
    title: 'Comprehensive Ecosystem',
    desc: 'A holistic ecosystem - supporting and partnering with our valued partners across all sectors, whether as Suppliers, Co-Sellers, or Co-branding collaborators.'
  },
  {
    icon: (
      <svg width="36" height="36" fill="none" stroke="#FE6019" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18" /><path d="M9 21V9" /></svg>
    ),
    title: 'VEA Group: Strategic Media & E-commerce Partner',
    desc: 'VEA Group - A trusted partner of leading media and e-commerce platforms in Vietnam and globally (TikTok, Shopee, etc.), while owning a vast Influencer ecosystem to powerfully support partners in boosting both sales and brand growth simultaneously.'
  },
  {
    icon: (
      <svg width="36" height="36" fill="none" stroke="#FE6019" strokeWidth="2" viewBox="0 0 24 24"><path d="M4 17l6-6 4 4 6-6" /><path d="M2 19h20" /></svg>
    ),
    title: 'Full-Scale Support from Our Network',
    desc: 'Receive comprehensive support from our alliance of member companies, covering Tech infrastructure (AI), legal and compliance issues, and more, for seamless business operations both domestically and internationally.'
  },
];

const BusinessStartSection: React.FC = () => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <section
      className="w-full flex flex-col md:flex-row items-center justify-between py-12 md:py-20 bg-white dark:bg-black transition-colors duration-500"
      style={{
        background: `url('/images/home/bg-overlay-home.png') center center / 80% auto no-repeat`,
      }}
    >
      {/* Illustration */}
      <div className="flex-1 flex items-center justify-center relative w-full md:w-1/2 mb-10 md:mb-0">
        {/* Orange wave background */}
        <svg className="absolute left-0 top-1/2 -translate-y-1/2 w-full h-full z-0" viewBox="0 0 800 400" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 200 Q200 100 400 200 T800 200" stroke="#FE6019" strokeWidth="3" fill="none" opacity="0.3" />
        </svg>
        <img
          src="/images/home/business_start.png"
          alt="Business Illustration"
          className={`relative z-10 w-[320px] md:w-[420px] lg:w-[520px] object-contain transition-transform duration-500 ${isHovered ? 'scale-110' : 'scale-100'}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        />
      </div>
      {/* Text Content */}
      <div className="flex-1 flex flex-col items-start justify-center w-full md:w-1/2 px-4 md:px-10 lg:px-20 gap-4">
        <span className="inline-block mb-3 px-4 py-1 rounded-full border border-[#FE6019] text-[#FE6019] bg-[#FE6019]/10 font-semibold text-xs md:text-sm tracking-wide">STRENGTHS OF VEA GROUP</span>
        <div className="flex flex-col gap-6 w-full">
          {benefits.map((b, i) => (
            <div key={i} className="flex items-start gap-4">
              <div className="flex-shrink-0 bg-white dark:bg-neutral-900 rounded-xl shadow p-2">{b.icon}</div>
              <div>
                <div className="font-bold text-gray-900 dark:text-white mb-1">{b.title}</div>
                <div className="text-gray-600 dark:text-gray-300 text-sm md:text-base">{b.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessStartSection; 